(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1896],{

/***/ 40293:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/q",
      function () {
        return __webpack_require__(1281);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Container": function() { return /* binding */ Container; },
  "LoadingWrapper": function() { return /* binding */ LoadingWrapper; },
  "default": function() { return /* binding */ q; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./api/constants/http.js
var http = __webpack_require__(23359);
// EXTERNAL MODULE: ./api/constants/resources.js
var resources = __webpack_require__(41238);
;// CONCATENATED MODULE: ./api/adLinks.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var adLinksAPI = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(body) {
        var res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,http/* default */.Z)(resources/* default.ADLINKS */.Z.ADLINKS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function adLinksAPI(body) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./components/layout/Seo.js + 4 modules
var Seo = __webpack_require__(65250);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./pages/q/index.js
function q_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function q_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                q_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                q_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100vw;\n  height: 100vh;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  & h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin-bottom: 30px;\n  }\n  & span {\n    margin-bottom: 30px;\n    font-size: 18px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-46507740-0"
})(_templateObject());
var LoadingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-46507740-1"
})(_templateObject1());
var QPage = function() {
    var router = (0,next_router.useRouter)();
    var fetchURL = function() {
        var _ref = q_asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "GetUrl",
                            code: router.query.code
                        };
                        _ctx.next = 3;
                        return adLinksAPI(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            router.push((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Link);
                        } else {
                            router.push("/");
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchURL() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (!router.isReady) return;
        fetchURL();
    }, [
        router.isReady
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: "/q"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "\uD3EC\uC7A5\uC7AC\uB294 \uCE7C\uB81B! | \uD3EC\uC7A5\uC7AC \uB9DE\uCDA4\uC81C\uC791\xb7\uCE5C\uD658\uACBD \uD3EC\uC7A5\uC7AC \uCE7C\uB81B\uC2A4\uD1A0\uC5B4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "naver-site-verification",
                        content: "73434c46afaf95b1aca89b69bf1bbd9b18d465c8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:site_name",
                        content: "\uCE7C\uB81B\uC2A4\uD1A0\uC5B4 :: \uBBF8\uB798\uC758 \uB2F9\uC5F0\uD568\uC744 \uB9CC\uB4E4\uB2E4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "\uD3EC\uC7A5\uC7AC\uB294 \uCE7C\uB81B! | \uD3EC\uC7A5\uC7AC \uB9DE\uCDA4\uC81C\uC791\xb7\uCE5C\uD658\uACBD \uD3EC\uC7A5\uC7AC \uCE7C\uB81B\uC2A4\uD1A0\uC5B4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "\uBC15\uC2A4\xb7\uBD09\uD22C\xb7\uD14C\uC774\uD504\xb7\uC644\uCDA9\uC7AC\uBD80\uD130 \uCE5C\uD658\uACBD \uD3EC\uC7A5\uC7AC\uAE4C\uC9C0. \uAE30\uC131\uD488 \uAD6C\uB9E4, \uC18C\uB7C9\uC778\uC1C4, \uB85C\uACE0\uC778\uC1C4, \uBE0C\uB79C\uB4DC \uB9DE\uCDA4\uC81C\uC791\uACFC \uAE30\uC5C5 \uB300\uB7C9\uACAC\uC801\uC744 \uD55C\uBC88\uC5D0 \uD574\uACB0\uD558\uC138\uC694."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.caretstore.co.kr"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://file.caretbio.com/caretbio/39c77d036143e36fb234b8281dc17bba.jpeg"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/assets/imgs/theme/logo-header-icon.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoadingWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "\uD398\uC774\uC9C0 \uC774\uB3D9\uC911\uC785\uB2C8\uB2E4."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var q = (QPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,2511,9774,2888,179], function() { return __webpack_exec__(40293); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);